<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="body-rw Chapter-rw" epub:type="bodymatter chapter" id="dedication">
<p class="ded_f"><span>My appreciation goes out to these people without whom I couldn’t have written this book, and so it’s for each and every one of you:</span></p>
<p class="ded"><span>To Devi, for taking a chance, and being so incredibly supportive.</span></p>
<p class="ded"><span>To Miriam, for always being in my corner.</span></p>
<p class="ded"><span>To Dr. Chris Fletcher, for being part of the process. Thank you so much!</span></p>
<p class="ded"><span>To my sisters, for always being there for me no matter what.</span></p>
<p class="ded"><span>To my favorite ginger, for the conversation that led to this book.</span></p>
<p class="ded"><span>To my friends, for understanding and putting up with all the crazy. I love you all.</span></p>
<p class="ded"><span>To Steve, for everything. Absolutely everything. I couldn’t do this without your love and support, and occasional kick in the butt.</span></p>
<p class="ded"><span>To all the girls in trouble out there. I hope you find your way out.</span></p>
<p class="ded"><span>And to W. You survived and you thrived. You forgave the unforgivable and found peace. You are strength and grace incarnate.</span></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?1d65befc